var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataTimePeriod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 150,
    viewBox: "0 0 246 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.14,
    x: 14,
    width: 216,
    height: 150,
    rx: 6,
    fill: "#00A9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M23 34.9521H222",
    stroke: "#00A9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M23 61.7139H222",
    stroke: "#00A9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M23 88.4756H222",
    stroke: "#00A9E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M23 115.237H222",
    stroke: "#00A9E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 135.449C22 135.025 22.3439 134.681 22.7682 134.681H36.0752C36.4994 134.681 36.8434 135.025 36.8434 135.449V142.326H22V135.449Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8286 127.804C38.8286 127.38 39.1726 127.036 39.5968 127.036H52.9038C53.3281 127.036 53.672 127.38 53.672 127.804V142.326H38.8286V127.804Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6567 112.514C55.6567 112.09 56.0007 111.746 56.425 111.746H69.7319C70.1562 111.746 70.5001 112.09 70.5001 112.514V142.327H55.6567V112.514Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7065 115.768C72.7065 115.344 73.0505 115 73.4748 115H86.9383C87.3626 115 87.7065 115.344 87.7065 115.768V142H72.7065V115.768Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3135 104.87C89.3135 104.446 89.6574 104.102 90.0817 104.102H103.389C103.813 104.102 104.157 104.446 104.157 104.87V142.327H89.3135V104.87Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.707 76.7682C105.707 76.3439 106.05 76 106.475 76H119.938C120.363 76 120.707 76.3439 120.707 76.7682V143H105.707V76.7682Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.707 98.7682C122.707 98.3439 123.05 98 123.475 98H136.938C137.363 98 137.707 98.3439 137.707 98.7682V142H122.707V98.7682Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.707 102.768C139.707 102.344 140.05 102 140.475 102H153.938C154.363 102 154.707 102.344 154.707 102.768V142H139.707V102.768Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.649 89.5788C156.649 89.1545 156.993 88.8105 157.417 88.8105H170.724C171.148 88.8105 171.492 89.1545 171.492 89.5788V142.326H156.649V89.5788Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.478 116.126C173.478 115.701 173.821 115.357 174.246 115.357H187.575C188 115.357 188.344 115.701 188.344 116.126V142.575H173.478V116.126Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.328 127.804C190.328 127.38 190.672 127.036 191.096 127.036H204.403C204.828 127.036 205.172 127.38 205.172 127.804V142.326H190.328V127.804Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M207.157 135.449C207.157 135.025 207.501 134.681 207.925 134.681H221.232C221.656 134.681 222 135.025 222 135.449V142.326H207.157V135.449Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 68.4182L30.9251 59.2198L49.0827 54.0276C50.1401 53.7253 51.2781 54.0257 52.0484 54.8105L66.4282 69.4598C67.6638 70.7186 69.7135 70.6449 70.8555 69.3006L76.7163 62.4015C77.7008 61.2427 79.3966 61.0036 80.6631 61.8452L96.1308 72.1237C96.9704 72.6817 98.0342 72.7806 98.9623 72.3871L117.48 64.5348C118.875 63.9436 120.491 64.4843 121.249 65.7954L137.013 93.0656C138.035 94.8336 140.486 95.086 141.847 93.5634L153.482 80.5455C154.688 79.1959 156.805 79.2137 157.989 80.5834L163.488 86.949C164.549 88.1772 166.395 88.3388 167.653 87.3136L175.776 80.6958C176.481 80.1221 177.407 79.8984 178.295 80.0872L196.394 83.9349C196.808 84.0229 197.236 84.0223 197.65 83.9332L207.958 81.7128C208.741 81.5442 209.424 81.0698 209.855 80.395L219.259 65.6725C219.602 65.1352 220.108 64.7213 220.702 64.4907L244.491 55.2595",
    stroke: "#00A9E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataTimePeriod);
export default __webpack_public_path__ + "static/media/no-data-time-period.e2dbde6d1cd89adb8c93bb55ae580eda.svg";
export { ForwardRef as ReactComponent };